import type { TextSegment } from '@civilgrid/ui/components';

/**
 * The confidentiality notice shown on the welcome disclaimer and both export acknowledgements.
 *
 * A surface supplies its own lead-in, which must end in "represents" for the two to read as one
 * sentence.
 */
export const CONFIDENTIALITY_NOTICE: readonly TextSegment[] = [
  { text: 'proprietary, sensitive, and confidential third-party information that, for reasons of security, ' },
  { text: 'is exempt from disclosure and shall not be subject to release', bold: true },
  {
    text: ' under any federal, state, or local public records, freedom of information, open records, or open meetings ("sunshine") law, including but not limited to the federal Freedom of Information Act (5 U.S.C. § 552) and any comparable state or local statute or regulation.',
  },
];

export const WELCOME_DISCLAIMER_LEAD_IN = 'Information accessible through CivilGrid represents';

export const WELCOME_DISCLAIMER_TITLE = 'Welcome to CivilGrid';

export const WELCOME_DISCLAIMER_ACCEPT_LABEL = 'Accept';

/** Wraps the two document links: "…agreed to <ToU> and <Privacy Notice>, which provide…". */
export const WELCOME_DISCLAIMER_INTRO = {
  beforeDocuments: 'By clicking below and using the CivilGrid Services, you agree that you have read and agreed to',
  betweenDocuments: 'and',
  afterDocuments: ', which provide, among other things, the following:',
} as const;

export const TERMS_OF_USE_DOCUMENT = {
  label: 'CivilGrid Terms of Use',
  href: 'https://drive.google.com/uc?export=download&id=1ivF-Bl1Hcxqj6SLytM9RlhiBOte9CBO1',
  fileName: 'CivilGridTermsOfUse.pdf',
} as const;

export const PRIVACY_NOTICE_DOCUMENT = {
  label: 'CivilGrid Privacy Notice',
  href: 'https://drive.google.com/uc?export=download&id=1XciSJ0JtW0IVyjItiDSPgS2FkmGKMkeJ',
  fileName: 'CivilGridPrivacyNotice.pdf',
} as const;

/** The first three bullets; the fourth is the shared confidentiality notice, which varies by surface. */
export const WELCOME_DISCLAIMER_BULLETS: readonly (readonly TextSegment[])[] = [
  [
    {
      text: 'CivilGrid attempts to provide comprehensive and accurate data for its users. Nonetheless, data contained in the CivilGrid platform is known to be incomplete and contain inaccuracies.',
    },
  ],
  [
    { text: 'Use of CivilGrid services does not preclude you from ' },
    { text: 'calling locate and mark services (811)', bold: true },
    {
      text: ', and employing other proper safe digging practices prior to initiating construction. We expect you to follow all safe digging legal requirements and best practices.',
    },
  ],
  [
    { text: 'Much of the data contained in the CivilGrid platform is ' },
    { text: 'confidential', bold: true },
    {
      text: '. You may not share data downloaded from CivilGrid with third parties unless it is part of a project deliverable owed to a client in the form of engineering drawings, or a specific project report. All deliverables containing CivilGrid data must be marked ',
    },
    { text: 'confidential', bold: true },
    { text: '.' },
  ],
];
